module.exports = __webpack_public_path__ + "assets/img/77@3x.079852cc.png";